import { FunctionComponent } from "react";
import * as Styled from "./query-error.style";

type QueryErrorPanelProps = {
	error: string;
};
export const QueryErrorPanel: FunctionComponent<QueryErrorPanelProps> = ({
	error,
}) => {
	return (
		<Styled.Root>
			<Styled.CriticalErrorHeader>
				{`<app-name> - CRITICAL ERROR`}
			</Styled.CriticalErrorHeader>
			<Styled.ErrorHeader>Error:</Styled.ErrorHeader>
			<Styled.ErrorMessage>{error}</Styled.ErrorMessage>
		</Styled.Root>
	);
};
